// extracted by mini-css-extract-plugin
module.exports = {"EmbedTweet":"styles_EmbedTweet__xzsao"};